export const GET_ALLUPSTREAMS_SUCCESS = "explorer/GET_ALLUPSTREAM_SUCCESS";
export const GET_ALLUPSTREAMS_FAILURE = "explorer/GET_ALLUPSTREAMS_FAILURE";
export const GET_SINGLEUPSTREAMS_SUCCESS = "explorer/GET_SINGLEUPSTREAMS_SUCCESS";
export const GET_SINGLEUPSTREAMS_FAILURE = "explorer/GET_SINGLEUPSTREAMS_FAILURE";